export const GROUPS_REQUEST = 'GROUPS_REQUEST';
export const GROUPS_SUCCESS = 'GROUPS_SUCCESS';
export const GROUPS_FAIL = 'GROUPS_FAIL';

export const GROUPS_SELECT = 'GROUPS_SELECT';


export const GROUPSDEL_REQUEST = 'GROUPSDEL_REQUEST';
export const GROUPSDEL_SUCCESS = 'GROUPSDEL_SUCCESS';
export const GROUPSDEL_FAIL = 'GROUPSDEL_FAIL';



// WEBPACK FOOTER //
// ./src/constants/Groups.js